<div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-lg mx-auto flex flex-col max-h-[92vh]">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <div>
        <h2 class="text-lg font-bold text-gray-900 leading-tight">New tenant</h2>
        <p class="text-xs text-gray-400">Create a new organization</p>
      </div>
    </div>
    <button type="button" (click)="closeModal()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>
  </div>

  <form (ngSubmit)="onSubmit()" class="flex flex-col flex-1 min-h-0">
    <div class="px-6 py-5 space-y-5 bg-gray-50/40">
      <div class="flex flex-col">
        <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Tenant name <span class="text-red-500">*</span></label>
        <input type="text" name="name" [(ngModel)]="tenantData.name" required placeholder="e.g. Company ABC"
          class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition" />
      </div>

      <div class="flex items-start gap-3 p-4 bg-blue-50 rounded-xl border border-blue-100">
        <svg class="w-5 h-5 text-blue-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        <div class="text-sm text-blue-700">
          <p class="font-semibold">What is a tenant?</p>
          <p class="text-blue-600 mt-1">A tenant represents an organization or company. Employees and projects can be assigned to specific tenants for better organization and access control.</p>
        </div>
      </div>
    </div>

    <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 bg-gray-50/50 shrink-0">
      <button type="button" (click)="closeModal()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
      <button type="submit" [disabled]="isSubmitting || !tenantData.name.trim()"
        class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm cursor-pointer flex items-center gap-2">
        @if(isSubmitting) { <span class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span> }
        {{ isSubmitting ? 'Creating…' : 'Create tenant' }}
      </button>
    </div>
  </form>
</div>
